exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".changeapp[data-v-219f3034]{padding-top:20px;padding-right:20px}.changeapp .btn[data-v-219f3034]{width:100%;text-align:center}\n", ""]);

// exports
